/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useSelector } from 'react-redux'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { RootState } from 'store/store'
import { DNSModeType } from 'models/enums'

import DnsModeForm from 'containers/domains/forms/dnsModeForm'
import AddRecordForm from 'containers/domains/forms/addRecordForm'
import EditRecordForm from 'containers/domains/forms/editRecordForm'
import EditNameserversForm from 'containers/domains/forms/editNameserversForm'
import AddNameserverForm from 'containers/domains/forms/addNameserverForm'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Dns() {
    const { dnsMode } = useSelector((state: RootState) => state.domain)

    function renderDNSRecordForm() {
        switch (dnsMode) {
            case DNSModeType.DNSHosting:
                return (
                    <>
                        <AddRecordForm/>
                        <EditRecordForm/>
                    </>
                )
            case DNSModeType.CustomNameservers:
                return (
                    <>
                        <AddNameserverForm/>
                        <EditNameserversForm/>
                    </>
                )
            case DNSModeType.Parked:
                return <ParkedDomain>Domain is currently parked.</ParkedDomain>
            default:
                return null
        }
    }

    return (
        <DnsWrapper>
            <DnsModeForm/>
            {renderDNSRecordForm()}
        </DnsWrapper>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const DnsWrapper = styled.div`
    width: 100%;
`

const ParkedDomain = styled.span`
    padding: 12px 20px;
    background-color: #f0f1f2;
    color: ${props => (props.theme['text--100'])};
    font-size: .875rem;
`
